export default "__VITE_ASSET__jI6efEXu__"